import LegacyCertificatePage from '../LegacyCertificatePage';

const TechLearningCertificate = () => <LegacyCertificatePage program="Tech Learning" backTo="/tech-learning/my-courses" />;

export default TechLearningCertificate;
